<!--
 * @Description: 预览作品
 * @Author: PF
 * @Date: 2023-12-11 17:04:46
 * @LastEditors: PF
 * @LastEditTime: 2024-02-04 10:22:20
-->

<template>
  <div>
    <el-dialog class="w800 h550" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="组织类型" label-align="right" align="left" width="120px" span="2"><span v-if="ruleForm.zzlx">{{ruleForm.zzlx.name}}</span></el-descriptions-item>
        <el-descriptions-item label="事务名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.zzswmc}}</el-descriptions-item>
        <el-descriptions-item label="组织事务类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.zzswlxmc}}</el-descriptions-item>
        <el-descriptions-item label="开始日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.ksrq}}</el-descriptions-item>
        <el-descriptions-item label="结束日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.jsrq}}</el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" width="120px" span="2"><span v-if="ruleForm.zt">{{ruleForm.zt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="事务内容" label-align="right" align="left" width="120px" span="2">{{ruleForm.zzswnr}}</el-descriptions-item>
        <el-descriptions-item label="附件" label-align="right" align="left" width="120px" span="2">
          <span style="color: #409EFF;cursor: pointer;" @click="openFuJian=true;row={listFj:scope.row.listFj||[]}">预览</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import fujian from '@/components/fujian.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})


const openFuJian = ref(false)

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/zuzhi/zuzhishiwu/canyurenyuanfujianyulan/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
